import { IconButton, Snackbar } from "@mui/joy";
import Box from "@mui/joy/Box";
import Button from "@mui/joy/Button";
import Checkbox from "@mui/joy/Checkbox";
import Divider from "@mui/joy/Divider";
import FormControl from "@mui/joy/FormControl";
import FormLabel from "@mui/joy/FormLabel";
import Input from "@mui/joy/Input";

import Stack from "@mui/joy/Stack";
import Typography from "@mui/joy/Typography";
import {
  browserLocalPersistence,
  setPersistence,
  signInWithEmailAndPassword,
} from "firebase/auth";
import * as React from "react";
import { Link, useNavigate } from "react-router";
import { auth } from "../../config/firebase";
import { Visibility, VisibilityOff } from "@mui/icons-material";

export default function Login() {
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const [remenberme, setRemenberme] = React.useState(false);
  const [values, setValues] = React.useState({
    email: "",
    password: "",
    showPassword: false,
  });
  const [open, setOpen] = React.useState({
    open: false,
    message: "Incorrect login ",
  });

  const handleChange = (event) => {
    setValues({ ...values, [event.target.name]: event.target.value });
  };

  const handleClose = () => {
    setOpen({ ...open, open: false });
  };

  const handleClickShowPassword = () => {
    setValues({ ...values, showPassword: !values.showPassword });
  };

  const changepersistance = (bol) => {
    setRemenberme(bol);
    console.log(bol);
  };

  const submitLogin = (event) => {
    event.preventDefault();
    setLoading(true);

    //set persistan
    setPersistence(auth, browserLocalPersistence)
      .then(() => {
        return signInWithEmailAndPassword(auth, values.email, values.password);
      })
      .then((userCredential) => {
        // Signed in
        setLoading(false);
        navigate(navigate("/"));
        // ...
      })
      .catch((error) => {
        // const errorCode = error.code;
        const errorMessage = error.message;
        console.log(errorMessage);

        setOpen({
          ...open,
          open: true,
          message: "Sorry incorrect login credentials",
        });
        setLoading(false);
      });
  };

  return (
    <Box
      component="main"
      sx={{
        my: 5,
        py: 2,
        pb: 5,
        display: "flex",
        flexDirection: "column",
        gap: 2,
        width: 400,
        maxWidth: "100%",
        mx: "auto",
        borderRadius: "sm",
        "& form": {
          display: "flex",
          flexDirection: "column",
          gap: 2,
        },
        [`& .MuiFormLabel-asterisk`]: {
          visibility: "hidden",
        },
      }}
    >
      <Stack sx={{ gap: 1 }}>
        <Typography component="h1" level="h3">
          Sign in
        </Typography>
        <Typography level="body-sm">
          New wallet?{" "}
          <Link
            to={"/auth/register"}
            style={{ textDecoration: "none", color: "#0c6bcc" }}
          >
            Sign up!
          </Link>
        </Typography>
      </Stack>

      <Divider
        sx={(theme) => ({
          [theme.getColorSchemeSelector("light")]: {
            color: { xs: "#FFF", md: "text.tertiary" },
          },
        })}
      ></Divider>
      <Stack sx={{ gap: 4, mt: 2 }}>
        <form onSubmit={submitLogin}>
          <FormControl size="lg" required>
            <FormLabel>Email</FormLabel>
            <Input onChange={handleChange} type="email" name="email" required />
          </FormControl>
          <FormControl size="lg" required>
            <FormLabel>Password</FormLabel>
            <Input
              sx={{ "--Input-decoratorChildHeight": "45px" }}
              type={values.showPassword ? "text" : "password"}
              onChange={handleChange}
              name="password"
              required
              endDecorator={
                <IconButton
                  variant="plain"
                  color="neutral"
                  onClick={handleClickShowPassword}
                >
                  {values.showPassword ? <Visibility /> : <VisibilityOff />}
                </IconButton>
              }
            />
          </FormControl>
          <Stack sx={{ gap: 4, mt: 2 }}>
            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <Checkbox
                size="sm"
                label="Remember me"
                name="persistent"
                onChange={() => changepersistance(!remenberme)}
              />
              <Link
                to={"/auth/reset"}
                style={{ textDecoration: "none", color: "#0c6bcc" }}
              >
                Forgot your password?
              </Link>
            </Box>
            <Button loading={loading} type="submit" fullWidth>
              Sign in
            </Button>
          </Stack>
        </form>
      </Stack>
      <Snackbar
        color="warning"
        size="md"
        variant="soft"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        open={open.open}
        onClose={handleClose}
      >
        {open.message}
      </Snackbar>
    </Box>
  );
}
